import React from "react";
import styles from "../../styles/evento-detalle.module.css";

export function TabTransfer({ evento }) {
    const text = (evento?.transfer ?? "").trim();

    return (
        <div className={styles.card}>
            <div className={styles.cardBody}>
                {text ? (
                    <div style={{ whiteSpace: "pre-wrap", lineHeight: 1.5 }}>
                        {text}
                    </div>
                ) : (
                    <div className={styles.muted}>—</div>
                )}
            </div>
        </div>
    );
}
